import {
  CLEAN_TOUCHPOINTDISPLAY,
  SET_TOUCHPOINTDISPLAY,
  SET_TOUCHPOINTDISPLAY_LIST,
  SYNC_FAILED,
  SYNC_FINISHED,
  SYNC_INITIATED,
  TOUCHPOINTDISPLAY_CREATED,
  TOUCHPOINTDISPLAY_UPDATED,
  UPDATE_INITIATED,
  CREATE_INITIATED,
  TOUCHPOINTDISPLAY_DELETED,
  DELETE_INITIATED,
} from './actionTypes';
import {
  IFailedSyncAction,
  ISetTouchpointDisplayAction,
  ISetTouchpointDisplaysAction,
  ITouchpointDisplaysAction,
  ITouchpointDisplaysState,
  ITouchpointDisplay,
  IDeleteTouchpointDisplayAction,
} from './types';

const initialSync = {
  syncing: false,
  updateInitiated: false,
  createInitiated: false,
  deleteInitiated: false,
};

const resetActionsSync = {
  error: null,
  touchpointDisplayUpdated: false,
  touchpointDisplayCreated: false,
  touchpointDisplayDeleted: false,
  touchpointLogoCreated: false,
};

export const initialState = {
  loaded: false,
  touchpointDisplays: [],
  touchpointDisplay: null,
  ...initialSync,
  ...resetActionsSync,
};

export const reducer = (
  state: ITouchpointDisplaysState = initialState,
  action: ITouchpointDisplaysAction
): ITouchpointDisplaysState => {
  switch (action.type) {
    case SYNC_INITIATED:
      return { ...state, ...resetActionsSync, syncing: true };
    case SYNC_FINISHED:
      return { ...state, ...initialSync };
    case SET_TOUCHPOINTDISPLAY_LIST:
      return {
        ...state,
        touchpointDisplays: (action as ISetTouchpointDisplaysAction).payload,
        loaded: true,
      };
    case SET_TOUCHPOINTDISPLAY:
      return {
        ...state,
        touchpointDisplay: (action as ISetTouchpointDisplayAction).payload,
      };
    case TOUCHPOINTDISPLAY_UPDATED:
      return {
        ...state,
        touchpointDisplayUpdated: true,
      };
    case UPDATE_INITIATED:
      return {
        ...state,
        ...resetActionsSync,
        updateInitiated: true,
      };
    case TOUCHPOINTDISPLAY_CREATED:
      return {
        ...state,
        touchpointDisplayCreated: true,
      };
    case CREATE_INITIATED:
      return {
        ...state,
        ...resetActionsSync,
        createInitiated: true,
      };
    case TOUCHPOINTDISPLAY_DELETED:
      return {
        ...state,
        touchpointDisplays: state.touchpointDisplays.filter(
          (touchpointDisplay: ITouchpointDisplay) =>
            touchpointDisplay.displayId !== (action as IDeleteTouchpointDisplayAction).payload
        ),
        touchpointDisplayDeleted: true,
      };
    case DELETE_INITIATED:
      return {
        ...state,
        ...resetActionsSync,
        deleteInitiated: true,
      };
    case CLEAN_TOUCHPOINTDISPLAY:
      return {
        ...state,
        touchpointDisplay: null,
      };
    case SYNC_FAILED:
      return { ...state, error: (action as IFailedSyncAction).payload };
    default:
      return state;
  }
};
